/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import { Stack } from '@mui/system';
import { ContainerForm } from 'components/shared/container_form';
import InputBooleanFormik from 'components/shared/custom_input_boolean_formik';
import DocumentComponent from 'components/shared/document_component';
import { PageTitle } from 'components/shared/page_title';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import useCifaStore from 'stores/cifa/cifa.store';

interface Step1Props {
  onNext: () => void;
  formik: any;
}

const Step1: React.FC<Step1Props> = ({ onNext, formik }) => {
  const { cifa } = useCifaStore();
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const handleNext = () => {
    onNext();
  };

  useEffect(() => {
    if (!cifa.uuid) {
      navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
    }
  }, [cifa, anoReferencia, navigate]);

  return (
    <>
      <PageTitle
        title='Cumprimento do Termo Escolar'
        subtitle='Informe corretamente os dados sobre o cumprimento dos requisitos do Termo de Adesão pelo Município.'
      />

      <Stack marginX='4rem' spacing='2rem' flexDirection='column' maxWidth='1152px' width='100%'>
        <ContainerForm title='PMAF - Plano de Agricultura Familiar'>

          <Box marginBottom='1rem'>
            <InputBooleanFormik
              formik={formik}
              textBold={false}
              label='termo_escolar_pmaf_elaborado'
              labelTexto='O Município elaborou o Plano Municipal de Agricultura Familiar - PMAF?'
            />
          </Box>

          <Box marginBottom='1rem'>
            <InputBooleanFormik
              formik={formik}
              textBold={false}
              label='termo_escolar_pmaf_validado_seaf_mt'
              labelTexto='O PMAF foi validado pela SEAF-MT?'
            />
          </Box>

          <Box marginBottom='1rem'>
            <InputBooleanFormik
              formik={formik}
              textBold={false}
              label='termo_escolar_ato_normativo_publicado'
              labelTexto='O município publicou ato normativo municipal instituindo a coordenação e equipe técnica responsável pela elaboração do PMAF, com participação do CMDRS?'
            />
          </Box>

          {
            formik.values.termo_escolar_ato_normativo_publicado && (
              <FormControl fullWidth>
                <FormLabel sx={{ fontSize: '1rem', fontWeight: '400', color: '#000', marginTop: '1rem' }}>Upload do Ato Normativo</FormLabel>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  marginBottom='1rem'
                >
                  Faça o upload do Ato Normativo Municipal que institui o CMDRS
                </Typography>
                <DocumentComponent
                  key="ato-normativo-component"
                  formik={formik}
                  formikLabel='termo_escolar_ato_normativo_uuid'
                  uuid={formik.values.termo_escolar_ato_normativo_uuid}
                  setUuid={(uuid) => formik.setFieldValue('termo_escolar_ato_normativo_uuid', uuid)}
                  podeSubstituir={true}
                />
              </FormControl>
            )
          }
        </ContainerForm>


        <ContainerForm title='CMDRS - Conselho Municipal de Desenvolvimento Rural Sustentável'>
          <Box marginBottom='1rem'>

            <InputBooleanFormik
              formik={formik}
              textBold={false}
              label='termo_escolar_cmdrs_constituido'
              labelTexto='O município possui CMDRS constituído por Lei Municipal?'
            />

            {
              formik.values.termo_escolar_cmdrs_constituido && (
                <FormControl fullWidth>
                  <FormLabel sx={{ fontSize: '1rem', fontWeight: '400', color: '#000', marginTop: '1rem' }}> Upload das atas de reuniões (no mínimo, 04) do CMDRS em</FormLabel>
                  <Typography
                    variant='body2'
                    color='text.secondary'
                    marginBottom='1rem'
                  >
                    Faça o upload das atas de reuniões, as atas devem ser juntadas em um único arquivo PDF
                  </Typography>
                  <DocumentComponent
                    key="atas-reunioes-component"
                    formik={formik}
                    formikLabel='termo_escolar_atas_reunioes_uuid'
                    uuid={formik.values.termo_escolar_atas_reunioes_uuid}
                    setUuid={
                      (uuid) => {
                        formik.setFieldValue('termo_escolar_atas_reunioes_uuid', uuid);
                      }
                    }
                    podeSubstituir={true}
                  />
                </FormControl>
              )
            }
          </Box>
        </ContainerForm>

        <ContainerForm title='Formulário Prefeitura'>
          <Box marginBottom='1rem'>
            <FormControl>
              <FormLabel sx={{ fontSize: '1rem', fontWeight: '400', color: '#000' }}>O Município preencheu o Formulário Prefeitura?</FormLabel>
              <RadioGroup
                aria-labelledby='foreigner-label'
                value={false}
              >
                <FormControlLabel value={true} control={<Radio disabled />} label='Sim' />
                <FormControlLabel value={false} control={<Radio disabled />} label='Não' />
              </RadioGroup>
            </FormControl>
          </Box>
        </ContainerForm>

        <Stack
          spacing={2}
          alignItems='center'
          justifyContent='center'
          marginTop='2rem'
          direction='row'
        >
          <Button variant='text' color='primary'
            onClick={() => {
              navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
            }}
          >
            Voltar
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleNext}
          >
            Avançar
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default Step1;
